/* eslint react-hooks/exhaustive-deps: "warn" */

import cn from 'classnames';

import { useInt } from 'hooks/useInt';

import { Button } from 'ui/atoms/Button/Button';
import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';

import styles from './IndexFeatured.module.scss';

import { getKybSteps } from '../../HubListPage.data';
import { topicPath } from '../../paths';
import type { IndexFeaturedProps } from './IndexFeatured.types';

export const IndexFeatured = ({ lang, className }: IndexFeaturedProps) => {
  const { t } = useInt();

  return (
    <section className={cn(styles['section'], className)}>
      <div className={styles['panel']}>
        <div>
          <TitleBlock
            align="left"
            theme="dark"
            title={
              <>
                {t('Know Your Business.')}
                <br />
                <span>{t('Know what you are checking.')}</span>
              </>
            }
            description={t(
              'What a registry match proves, what it leaves open, and how identity evidence fits into a business onboarding decision.',
            )}
            className={styles['heading']}
          />

          <Button type="white" size="lg" href={topicPath('know-your-business', lang)} suffixIcon="arrow-forward">
            {t('Explore KYB')}
          </Button>
        </div>

        <ol className={styles['steps']}>
          {getKybSteps(t).map((step, index) => (
            <li key={step} className={styles['step']}>
              <span className={styles['number']}>{String(index + 1).padStart(2, '0')}</span>

              <span className={styles['label']}>{step}</span>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};
